module.exports = __webpack_public_path__ + "static/media/icon-back.5003b3a3.svg";